import Core from '../../../Core/Core';
import { HudActions } from '../../../Managers/Hud/HudEmitter';
import DateUtils from '../../../Utils/DateUtils';
import { createPixiText, scaleToFit } from '../../../Utils/Utils';
import { PlayerAvatarFrame } from '../../Map/PlayerAvatarFrame';
import { ILeaderBoardPlayer } from './LeaderBoard';
import { SocialGiftButton } from './SocialGiftButton';
import { ButtonColors } from '../../Shared/Buttons/NineSliceButton';

export const COOLDOWN = DateUtils.hoursToMilliseconds(48);

export class GiftFriendTab extends PIXI.Sprite {
    private emoji: PIXI.Sprite;
    private sendBtn: SocialGiftButton;
    private requestBtn: SocialGiftButton;

    constructor(
        playerData: ILeaderBoardPlayer,
        tabWidth: number,
        tabHeight: number,
        emojiState: boolean,
        canSendGifts: boolean
    ) {
        super();

        const textColor = playerData.isUser ? 0xff6600 : 0x006eba;
        const rect = new PIXI.Sprite(PIXI.utils.TextureCache['mapui/leaderboard-playertag-bg']);
        rect.anchor.set(0.5);
        // adjust for weird position caused by rect
        const offset = -rect.height * 0.05;

        const emoji = new PIXI.Sprite(PIXI.utils.TextureCache['mapui/giftstab-smiley']);
        emoji.anchor.set(0.5);
        emoji.scale.set(0.7);
        emoji.x = -tabWidth * 0.4;
        emoji.y = offset;
        emoji.alpha = emojiState ? 1 : 0.5;
        this.emoji = emoji;

        const avatar = new PlayerAvatarFrame(playerData.url, false);
        avatar.x = -tabWidth * 0.25;
        avatar.y = offset;
        avatar.scale.set(scaleToFit(avatar.width, avatar.height, rect.width, rect.height * 0.9));
        const playerName = createPixiText(
            playerData.name,
            new PIXI.Rectangle(
                tabWidth * 0.15,
                -rect.height * 0.25 + offset,
                rect.width * 0.7,
                rect.height
            ),
            'Baloo',
            26,
            26,
            textColor
        );
        playerName.anchor.set(0.5);
        if (canSendGifts) {
            const sendButton = new SocialGiftButton(
                tabWidth * 0.3,
                tabHeight * 0.6,
                Core.local.getText('send'),
                playerData.id,
                HudActions.SOCIALHUB_SEND_GIFT
            );
            sendButton.x = 0;
            sendButton.y = rect.height * 0.15;
            this.sendBtn = sendButton;
        }

        const requestButton = new SocialGiftButton(
            canSendGifts ? tabWidth * 0.3 : tabWidth,
            tabHeight * 0.6,
            Core.local.getText('request'),
            playerData.id,
            HudActions.SOCIALHUB_REQUEST_GIFT,
            ButtonColors.PINK
        );
        requestButton.x = canSendGifts ? tabWidth * 0.3 : tabWidth * 0.15;
        requestButton.y = rect.height * 0.15;
        this.requestBtn = requestButton;

        //@ts-ignore
        this.addChild(rect, emoji, avatar, playerName, requestButton);
        if (canSendGifts) {
            this.addChild(this.sendBtn);
        }

        this.pivot.x = rect.width / 2;
        this.pivot.y = 0;
    }

    public updateButtonTime(sendtime: number, requesttime: number, waitingFor: string) {
        let sendButtonTime = sendtime ? DateUtils.timeRemainingTo(COOLDOWN + sendtime) : null;
        if (this.sendBtn) {
            this.sendBtn.updateTimer(sendButtonTime);
            if (sendButtonTime <= 0) {
                sendButtonTime = null;
            }
        }
        let requestButtonTime = requesttime
            ? DateUtils.timeRemainingTo(COOLDOWN + requesttime)
            : null;
        if (requestButtonTime <= 0) {
            requestButtonTime = null;
        }

        this.requestBtn.updateTimer(requestButtonTime);

        if (waitingFor === 'sent' && sendButtonTime) {
            this.setEmoji(true);
        } else if (waitingFor === 'request' && requestButtonTime) {
            this.setEmoji(true);
        } else {
            this.setEmoji(false);
        }
    }

    public setDraggin(bool: boolean) {
        if (this.sendBtn) {
            this.sendBtn.setDragging(bool);
        }
        this.requestBtn.setDragging(bool);
    }

    public setEmoji(emojiState: boolean) {
        this.emoji.alpha = emojiState ? 1 : 0.5;
    }
}
